export const seladData = {
  id: 'selad_base',
  delivery_time: '',
  delivery_order: 0,
  arrival_place: false,
  start_discharge: false,
  end_discharge: false,
  truck_route_id: 'selad_transportes_truck_id',
  invoice_id: 'selad_transportes',
  longitude: -46.44126057503965,
  latitude: -23.563803174216396,
  invoice: {
    id: 'selad_transportes',
    invoice_number: '--',
    order_number: '--',
    client_name: 'Selad Transportes',
    cubage: '0',
    amount_boxes: 0,
    invoice_was_received: false,
    cep: '--',
    address: '--',
    longitude: -46.44126057503965,
    latitude: -23.563803174216396,
    status: '--',
    was_delivered: false,
    position_id: null,
    position_occupied: false,
    amount_read_labels: 0,
    collection_completed: true,
    storage_completed: true,
    available_for_route: true,
    user_id: '--',
    truck_id: null,
    driver_id: null,
    current_status: null,
    status_id: null,
    created_at: '--',
    updated_at: '--',
    weight: 0,
  },
  created_at: '2021-12-02T14:27:17.678Z',
  updated_at: '2021-12-02T14:27:17.678Z',
};

export const routeItemExample = {
  id: '',
  delivery_time: '',
  delivery_order: 0,
  arrival_place: false,
  start_discharge: false,
  end_discharge: false,
  truck_route_id: '',
  invoice_id: '',
  longitude: -46.44126057503965,
  latitude: -23.563803174216396,
  invoice: {
    id: 'selad_transportes',
    invoice_number: '--',
    order_number: '--',
    client_name: 'Selad Transportes',
    cubage: '0',
    amount_boxes: 0,
    invoice_was_received: false,
    cep: '--',
    address: '--',
    position: '',
    collection_orders: [],
    user: {
      individual_person: {
        name: '',
      },
      legal_person: {
        name: '',
      },
    },
    invoice_progress: [],
    pallets: [],
    route_item: {
      truck_route: {
        id: '',
        truck: {
          name: '',
        },
        driver: {
          individual_person: {
            name: '',
          },
        },
      },
    },
    longitude: -46.44126057503965,
    latitude: -23.563803174216396,
    status: '--',
    was_delivered: false,
    position_id: null,
    position_occupied: false,
    amount_read_labels: 0,
    collection_completed: true,
    storage_completed: true,
    available_for_route: true,
    user_id: '--',
    truck_id: null,
    driver_id: null,
    current_status: null,
    status_id: null,
    created_at: '--',
    updated_at: '--',
    weight: 0,
  },
  created_at: '2021-12-02T14:27:17.678Z',
  updated_at: '2021-12-02T14:27:17.678Z',
};
